import { Gallery } from "../gallery/gallery";
import "./about.css";

export const About = () => {
  return (
    <>
      <section class="legacy-section">
        <h2>A Legacy Of Spiritual Excellence</h2>
        <div class="legacy-content">
          <h3>Preserving Traditions, Enriching Souls</h3>
          <p>
            Vaidika Vignanam Samvardhini – Your Gateway to Timeless Rituals and
            Spiritual Wisdom
          </p>
          <h3>Timeless Traditions, Sacred Devotion</h3>
          <p>
            Established in 2010, Vaidika Vignanam Samvardhini stands as a pillar
            of authenticity and tradition in Telugu rituals. Our expert in-house
            priests, certified by SV Vedic University, bring unmatched
            precision, care, and reverence to every ritual. Specializing in
            personalized pujas, we combine process-driven services with a
            commitment to educating our clients, offering a seamless and
            enriching experience. Dedicated to serving Telugu-speaking families
            across India, we proudly preserve and honor sacred traditions with
            unwavering devotion.
          </p>
          <p>
            With a legacy rooted in spiritual excellence, we bridge ancient
            traditions with modern needs. Let us guide your sacred journey with
            trust, expertise, and heartfelt dedication.
          </p>
          <h3>A Legacy of Knowledge and Faith</h3>
          <p>
            The founder of Vaidika Vignanam Samvardhini is a proud graduate of
            the prestigious S.V Vedic University, T.T.D Tirupati. With a
            deep-rooted passion for preserving Telugu traditions, they
            established the brand to serve the community with authenticity and
            care. Their vision is to provide not just rituals but a journey of
            spiritual enrichment, ensuring each customer receives personalized,
            process-driven services that uphold the sanctity of every puja.
          </p>
          <h3>The Heart of Tradition, The Spirit of Devotion</h3>
          <ul class="legacy-list">
            <li data-icon="📜">SVV University Certified Priests</li>
            <li data-icon="🙏">Tailored for Telugu Families</li>
            <li data-icon="🌍">Multilingual Priests</li>
            <li data-icon="⚖️">Process-Driven Approach</li>
            <li data-icon="📖">Emphasis on Knowledge</li>
            <li data-icon="🏠">In-House Experts</li>
            <li data-icon="📦">Comprehensive Material Support</li>
          </ul>
          <h3>Get in Touch with Us</h3>
          <p>
            We’re here to guide you on your spiritual journey. Reach out for
            personalized puja consultations, support, or inquiries.
          </p>
        </div>
      </section>
      <Gallery />
    </>
  );
};
